import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AddActivityModalComponent } from './add-activity-modal/add-activity-modal.component';
import { AddCompanyModalComponent } from './add-company-modal/add-company-modal.component';
import { AddConnectionModalComponent } from './add-connection-modal/add-connection-modal.component';
import { AddImplementModalComponent } from './add-implement-modal/add-implement-modal.component';
import { AddJobModalComponent } from './add-job-modal/add-job-modal.component';
import { AddMachineModalComponent } from './add-machine-modal/add-machine-modal.component';
import { AddNutrientPlanModalComponent } from './add-nutrient-plan-modal/add-nutrient-plan-modal.component';
import { AddPlanModalComponent } from './add-plan-modal/add-plan-modal.component';
import { AddTagModalComponent } from './add-tag-modal/add-tag-modal.component';
import { AddUserModalComponent } from './add-user-modal/add-user-modal.component';
import { ApplyConflictedTagsModalComponent } from './apply-conflicted-tags/apply-conflicted-tags-modal.component';
import { AutomaticImportRecommendationModalComponent } from './automatic-import-recommendation-modal/automatic-import-recommendation-modal.component';
import { AddBusinessModalComponent } from './businesses/add/add-business-modal.component';
import { EditHoldingsModalComponent } from './businesses/holdings/edit-holdings-modal.component';
import { ImportBusinessModalComponent } from './businesses/import/import-business-modal.component';
import { EditActivityDefaultSettingsModalComponent } from './edit-activity-default-settings/edit-activity-default-settings-modal.component';
import { EditAddressModalComponent } from './edit-address-modal/edit-address-modal.component';
import { EditJobActualProductsModalComponent } from './edit-job-actual-products-modal/edit-job-actual-products-modal.component';
import { EditWorkOrderFieldModalComponent } from './edit-job-field-modal/edit-job-field-modal.component';
import { EditJobFieldsModalComponent } from './edit-job-fields-modal/edit-job-fields-modal.component';
import { EditJobProductModalComponent } from './edit-job-product-modal/edit-job-product-modal.component';
import { EditJobProductsModalComponent } from './edit-job-products-modal/edit-job-products-modal.component';
import { EditOverrideModalComponent } from './edit-override-modal/edit-override-modal.component';
import { EditTagModalComponent } from './edit-tag-modal/edit-tag-modal.component';
import { FieldReportModalComponent } from './field-report-modal/field-report-modal.component';
import { AddFieldModalComponent } from './fields/add/add-field-modal.component';
import { CropFailureModalComponent } from './fields/crop-failure/crop-failure-modal.component';
import { EditFieldCroppingAreasSequenceSidebarComponent } from './fields/cropping-areas/sequence-sidebar/sequence-sidebar.component';
import { CopyFromCroppingRecordsModalComponent } from './fields/cropping-planner/copy-from/copy-cropping-records-modal.component';
import { CopyToCroppingRecordsModalComponent } from './fields/cropping-planner/copy-to/copy-to-cropping-records-modal.component';
import { UpdateCroppingRecordsModalComponent } from './fields/cropping-planner/update-cropping-records-modal.component';
import { EditFieldCroppingRecordsV2ModalComponent } from './fields/cropping-records-v2/cropping-records-v2-modal.component';
import { EditFieldCroppingRecordsModalComponent } from './fields/cropping-records/cropping-records-modal.component';
import { AddInspectionModalComponent } from './inspections/add/add-inspection-modal.component';
import { EditInspectionObservationsModalComponent } from './inspections/observations/edit-observations-modal.component';
import { ObservationPhotoModalComponent } from './inspections/photo/observation-photo-modal.component';
import { SoilSampleObservationResultsModalComponent } from './inspections/soil-sample/observation-results-modal.component';
import { EmailShareKeyPersonnelModalComponent } from './personnel/email-share-key/email-share-key-personnel-modal.component';
import { AdjuvantPickerModalComponent } from './products/add/adjuvant/adjuvant-picker-modal.component';
import { BiostimulantPickerModalComponent } from './products/add/biostimulant/biostimulant-picker-modal.component';
import { BiostimulantPickerModalService } from './products/add/biostimulant/biostimulant-picker-modal.service';
import { CustomProductModalComponent } from './products/add/custom/custom-product-modal.component';
import { ProductFoundModalComponent } from './products/add/custom/product-found/product-found-modal.component';
import { FertiliserPickerModalComponent } from './products/add/fertiliser/fertiliser-picker-modal.component';
import { FertiliserPickerModalService } from './products/add/fertiliser/fertiliser-picker-modal.service';
import { AddOtherProductModalComponent } from './products/add/other/add-other-product-modal.component';
import { PesticidePickerModalComponent } from './products/add/pesticide/pesticide-picker-modal.component';
import { PesticidePickerModalService } from './products/add/pesticide/pesticide-picker-modal.service';
import { SeedPlantPickerModalComponent } from './products/add/seed-plant/seed-plant-picker-modal.component';
import { SeedPlantPickerModalService } from './products/add/seed-plant/seed-plant-picker-modal.service';
import { SeedPlantProductModalComponent } from './products/add/seed-plant/seed-plant-product-modal.component';
import { ManureNutrientsModalComponent } from './products/manure-nutrients/manure-nutrients-modal.component';
import { ProductNutrientsModalComponent } from './products/nutrients/edit-product-nutrients-modal.component';
import { ProductSeedDressingModalComponent } from './products/seed-dressings/edit-seed-dressing-modal.component';
import { ProductUniqueValidationModalComponent } from './products/unique-validation/unique-validation-modal.component';
import { SaveStockAdjustmentModalComponent } from './save-stock-adjustment-modal/save-stock-adjustment-modal.component';
import { StockReportModalComponent } from './stock-report-modal/stock-report-modal.component';
import { AddTradeModalComponent } from './trades/add/add-trade-modal.component';
import { TradeCroppingRecordsPickerComponent } from './trades/cropping-records/trade-cropping-records-picker.component';
import { TradeProductsPickerComponent } from './trades/products/trade-products-picker.component';
import { SaveTradeTypeModalComponent } from './trades/trade-types/save-trade-type-modal.component';
import { ViewNotesModalComponent } from './view-notes-modal/view-notes-modal.component';
import { ViewReportModalComponent } from './view-report-modal/view-report-modal.component';
import { WarningModalComponent } from './warning-modal/warning-modal';
import { WeatherForecastModalComponent } from './weather/weather-forecast-modal.component';

@NgModule({
  declarations: [
    EditFieldCroppingRecordsModalComponent,
    EditFieldCroppingRecordsV2ModalComponent,
    AddTradeModalComponent,
    AddInspectionModalComponent,
    AddActivityModalComponent,
    AddImplementModalComponent,
    AddCompanyModalComponent,
    AddMachineModalComponent,
    EditInspectionObservationsModalComponent,
    ObservationPhotoModalComponent,
    SoilSampleObservationResultsModalComponent,
    EditJobActualProductsModalComponent,
    EditWorkOrderFieldModalComponent,
    EditJobFieldsModalComponent,
    EditJobProductModalComponent,
    EditJobProductsModalComponent,
    ProductNutrientsModalComponent,
    ManureNutrientsModalComponent,
    ProductSeedDressingModalComponent,
    SaveStockAdjustmentModalComponent,
    EditOverrideModalComponent,
    SaveTradeTypeModalComponent,
    TradeCroppingRecordsPickerComponent,
    TradeProductsPickerComponent,
    PesticidePickerModalComponent,
    FertiliserPickerModalComponent,
    AddFieldModalComponent,
    AddUserModalComponent,
    ViewReportModalComponent,
    AddBusinessModalComponent,
    EmailShareKeyPersonnelModalComponent,
    EditAddressModalComponent,
    EditHoldingsModalComponent,
    AddOtherProductModalComponent,
    FieldReportModalComponent,
    ViewNotesModalComponent,
    CopyFromCroppingRecordsModalComponent,
    UpdateCroppingRecordsModalComponent,
    EditFieldCroppingAreasSequenceSidebarComponent,
    AddJobModalComponent,
    AddTagModalComponent,
    ApplyConflictedTagsModalComponent,
    EditTagModalComponent,
    AddPlanModalComponent,
    AddConnectionModalComponent,
    AutomaticImportRecommendationModalComponent,
    CopyToCroppingRecordsModalComponent,
    WeatherForecastModalComponent,
    WarningModalComponent,
    ImportBusinessModalComponent,
    AdjuvantPickerModalComponent,
    CustomProductModalComponent,
    ProductFoundModalComponent,
    SeedPlantProductModalComponent,
    BiostimulantPickerModalComponent,
    SeedPlantPickerModalComponent,
    EditActivityDefaultSettingsModalComponent,
    ProductUniqueValidationModalComponent,
    CropFailureModalComponent,
    StockReportModalComponent,
    AddNutrientPlanModalComponent
  ],
  imports: [CommonModule, SharedModule, RouterModule, DragDropModule],
  exports: [
    EditFieldCroppingRecordsModalComponent,
    EditFieldCroppingRecordsV2ModalComponent,
    AddTradeModalComponent,
    AddInspectionModalComponent,
    AddActivityModalComponent,
    AddImplementModalComponent,
    AddCompanyModalComponent,
    AddMachineModalComponent,
    EditInspectionObservationsModalComponent,
    ObservationPhotoModalComponent,
    SoilSampleObservationResultsModalComponent,
    EditJobActualProductsModalComponent,
    EditWorkOrderFieldModalComponent,
    EditJobFieldsModalComponent,
    EditJobProductModalComponent,
    EditJobProductsModalComponent,
    ProductNutrientsModalComponent,
    ManureNutrientsModalComponent,
    ProductSeedDressingModalComponent,
    SaveStockAdjustmentModalComponent,
    EditOverrideModalComponent,
    SaveTradeTypeModalComponent,
    TradeCroppingRecordsPickerComponent,
    TradeProductsPickerComponent,
    PesticidePickerModalComponent,
    FertiliserPickerModalComponent,
    AddFieldModalComponent,
    AddUserModalComponent,
    ViewReportModalComponent,
    AddBusinessModalComponent,
    EmailShareKeyPersonnelModalComponent,
    EditAddressModalComponent,
    EditHoldingsModalComponent,
    AddOtherProductModalComponent,
    FieldReportModalComponent,
    ViewNotesModalComponent,
    CopyFromCroppingRecordsModalComponent,
    UpdateCroppingRecordsModalComponent,
    EditFieldCroppingAreasSequenceSidebarComponent,
    AddJobModalComponent,
    AddTagModalComponent,
    ApplyConflictedTagsModalComponent,
    EditTagModalComponent,
    AddPlanModalComponent,
    AddConnectionModalComponent,
    AutomaticImportRecommendationModalComponent,
    CopyToCroppingRecordsModalComponent,
    WeatherForecastModalComponent,
    WarningModalComponent,
    ImportBusinessModalComponent,
    AdjuvantPickerModalComponent,
    CustomProductModalComponent,
    SeedPlantProductModalComponent,
    ProductFoundModalComponent,
    BiostimulantPickerModalComponent,
    SeedPlantPickerModalComponent,
    EditActivityDefaultSettingsModalComponent,
    ProductUniqueValidationModalComponent,
    CropFailureModalComponent,
    StockReportModalComponent,
    AddNutrientPlanModalComponent
  ],
  providers: [
    PesticidePickerModalService,
    BiostimulantPickerModalService,
    SeedPlantPickerModalService,
    FertiliserPickerModalService
  ]
})
export class ModalsModule {}
